export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export const ACCENT = '#667eea';
export const ACCENT_LIGHT = 'rgba(102, 126, 234, 0.08)';
export const DANGER = '#ef4444';
export const GRAY_700 = '#374151';
export const GRAY_500 = '#6b7280';
export const GRAY_400 = '#9ca3af';
export const GRAY_300 = '#d1d5db';
export const GRAY_200 = '#e5e7eb';
export const GRAY_100 = '#f3f4f6';

export const textFieldSx = (hasError) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    fontSize: '0.925rem',
    backgroundColor: '#fff',
    transition: 'box-shadow 0.2s ease',
    '& fieldset': {
      borderColor: hasError ? DANGER : GRAY_300,
      transition: 'border-color 0.2s ease',
    },
    '&:hover fieldset': {
      borderColor: hasError ? DANGER : ACCENT,
    },
    '&.Mui-focused fieldset': {
      borderColor: hasError ? DANGER : ACCENT,
      borderWidth: '2px',
    },
    '&.Mui-focused': {
      boxShadow: hasError ? `0 0 0 3px rgba(239,68,68,0.1)` : `0 0 0 3px ${ACCENT_LIGHT}`,
    },
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.925rem',
    color: GRAY_500,
    '&.Mui-focused': { color: hasError ? DANGER : ACCENT },
  },
  '& .MuiFormHelperText-root': {
    fontSize: '0.8rem',
    marginTop: '6px',
  },
});

export const selectSx = (hasError) => ({
  borderRadius: '8px',
  fontSize: '0.925rem',
  backgroundColor: '#fff',
  transition: 'box-shadow 0.2s ease',
  '& fieldset': {
    borderColor: hasError ? DANGER : GRAY_300,
    transition: 'border-color 0.2s ease',
  },
  '&:hover fieldset': {
    borderColor: hasError ? DANGER : ACCENT,
  },
  '&.Mui-focused fieldset': {
    borderColor: hasError ? DANGER : ACCENT,
    borderWidth: '2px',
  },
  '&.Mui-focused': {
    boxShadow: hasError ? `0 0 0 3px rgba(239,68,68,0.1)` : `0 0 0 3px ${ACCENT_LIGHT}`,
  },
});

export const formLabelSx = (hasError) => ({
  fontSize: '0.925rem',
  color: hasError ? DANGER : GRAY_500,
  '&.Mui-focused': { color: hasError ? DANGER : ACCENT },
});

const btnBase = {
  borderRadius: '8px',
  fontWeight: 600,
  fontSize: '0.875rem',
  padding: '8px 20px',
  textTransform: 'none',
  transition: 'all 0.2s ease',
  boxShadow: 'none',
};

export const btnPrimary = {
  ...btnBase,
  color: '#fff',
  background: ACCENT,
  '&:hover': {
    background: '#5a6fd6',
    boxShadow: '0 4px 12px rgba(102,126,234,0.35)',
  },
  '&.Mui-disabled': {
    background: GRAY_200,
    color: GRAY_400,
  },
};

export const btnSecondary = {
  ...btnBase,
  color: '#fff',
  background: '#f97316',
  '&:hover': {
    background: '#ea580c',
    boxShadow: '0 4px 12px rgba(249,115,22,0.3)',
  },
};

export const btnOutlined = {
  ...btnBase,
  color: GRAY_700,
  borderColor: GRAY_300,
  backgroundColor: '#fff',
  '&:hover': {
    borderColor: GRAY_500,
    backgroundColor: GRAY_100,
  },
  '&.Mui-disabled': {
    borderColor: GRAY_200,
    color: GRAY_400,
  },
};
